import SectionHeader from "../SectionHeader";
import { Link } from "react-router-dom";

export default function TrendingProducts() {
  return (
    <>
      <SectionHeader>Trending Products</SectionHeader>
      {/* section container */}
      <div className="w-full font-fontTwo">
        {/* upper part cards */}
        <div className="flex justify-between max-w-5xl mx-auto">
          <Card
            img={require("../../assets/home/trending-products/chair01.png")}
          />
          <Card
            img={require("../../assets/home/trending-products/chair02.png")}
          />
          <Card
            img={require("../../assets/home/trending-products/chair03.png")}
          />
          <Card
            img={require("../../assets/home/trending-products/chair04.png")}
          />
        </div>
        {/* lower part */}
        <div className=" max-w-5xl mx-auto mt-8 flex justify-between h-60">
          {/* left cards */}
          <div className="flex flex-1">
            {/* cards */}
            <div className="relative w-1/2 bg-[#FFF6FB]  pt-6 pl-6 mr-4">
              <img
                className=" max-w-full absolute right-0 bottom-0 -z-0"
                src={require("../../assets/home/trending-products/product01.png")}
                alt=""
              />
              <h4 className="font-bold text-2xl mb-2 text-text z-10 font-fontOne ">
                23% off in all products
              </h4>
              <Link to="shoplist" className="text-pink underline text-sm">
                Shop now
              </Link>
            </div>
            {/* card */}
            <div className="relative w-1/2 bg-bg_shade  pt-6 pl-6">
              <img
                className=" max-w-full absolute right-0 bottom-0 -z-0"
                src={require("../../assets/home/trending-products/product02.png")}
                alt=""
              />
              <h4 className="font-bold text-2xl mb-2 text-text z-10 font-fontOne ">
                23% off in all products
              </h4>
              <a href="/" className="text-pink underline text-sm">
                View Collection
              </a>
            </div>
          </div>
          {/* right list cards */}
          <div className=" w-72 pl-4 flex flex-col justify-between">
            <List
              img={require("../../assets/home/trending-products/product03.png")}
            />
            <List
              img={require("../../assets/home/trending-products/product04.png")}
            />
            <List
              img={require("../../assets/home/trending-products/product05.png")}
            />
          </div>
        </div>
      </div>
    </>
  );
}

function List({ img }) {
  return (
    <Link to="product/123" className="flex items-center text-text">
      <div className="bg-[#F5F6F8] w-24 mr-2 flex justify-center items-center">
        <img alt="" src={img} />
      </div>
      <div>
        <h6 className=" font-semibold ">Executive Seat Chair</h6>
        <div className="line-through text-xs font-semibold">$32.00</div>
      </div>
    </Link>
  );
}

function Card({ img }) {
  return (
    <div className=" font-semibold text-text shadow-custom_two w-60 p-3 mx-2 text-center pb-8">
      {/* image container */}
      <div className="bg-[#F5F6F8] h-52 mb-4 flex justify-center items-center">
        <img src={img} alt="" />
      </div>
      {/*  */}
      <h4 className=" mb-2 text-lg">Cantiliver Chair</h4>
      <p className="font-normal text-base font-fontOne">
        <span className="text-text">$26.00</span>
        &nbsp; &nbsp;
        <span className=" line-through text-[rgba(21,24,117,.3)]">$42.00</span>
      </p>
    </div>
  );
}
